"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var _core = require("@uppy/core");

var _RateLimitedQueue2 = require("@uppy/utils/lib/RateLimitedQueue");

function _classPrivateFieldLooseBase(receiver, privateKey) {
  if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) {
    throw new TypeError("attempted to use private field on non-instance");
  }

  return receiver;
}

var id = 0;

function _classPrivateFieldLooseKey(name) {
  return "__private_" + id++ + "_" + name;
}

var getFileNameAndExtension = require("@uppy/utils/lib/getFileNameAndExtension");

var prettierBytes = require("@transloadit/prettier-bytes");

var CompressorJS = require("compressorjs/dist/compressor.common.js");

var locale = require("./locale.js");

var _RateLimitedQueue = /*#__PURE__*/_classPrivateFieldLooseKey("RateLimitedQueue");

var Compressor = /*#__PURE__*/function (_core$BasePlugin) {
  _inherits(Compressor, _core$BasePlugin);

  var _super = _createSuper(Compressor);

  function Compressor(uppy, opts) {
    var _this;

    _classCallCheck(this, Compressor);

    _this = _super.call(this, uppy, opts);
    Object.defineProperty(_assertThisInitialized(_this), _RateLimitedQueue, {
      writable: true,
      value: void 0
    });
    _this.id = _this.opts.id || 'Compressor';
    _this.type = 'modifier';
    _this.defaultLocale = locale;
    var defaultOptions = {
      quality: 0.6,
      limit: 10
    };
    _this.opts = _objectSpread(_objectSpread({}, defaultOptions), opts);
    _classPrivateFieldLooseBase(_assertThisInitialized(_this), _RateLimitedQueue)[_RateLimitedQueue] = new _RateLimitedQueue2.RateLimitedQueue(_this.opts.limit);

    _this.i18nInit();

    _this.prepareUpload = _this.prepareUpload.bind(_assertThisInitialized(_this));
    _this.compress = _this.compress.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Compressor, [{
    key: "compress",
    value: function compress(blob) {
      var _this2 = this;

      return new Promise(function (resolve, reject) {
        /* eslint-disable no-new */
        new CompressorJS(blob, _objectSpread(_objectSpread({}, _this2.opts), {}, {
          success: resolve,
          error: reject
        }));
      });
    }
  }, {
    key: "prepareUpload",
    value: function () {
      var _prepareUpload = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(fileIDs) {
        var _this3 = this;

        var totalCompressedSize, compressAndApplyResult, promises, _iterator, _step, fileID, file;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                totalCompressedSize = 0;
                compressAndApplyResult = _classPrivateFieldLooseBase(this, _RateLimitedQueue)[_RateLimitedQueue].wrapPromiseFunction( /*#__PURE__*/function () {
                  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(file) {
                    var compressedBlob, compressedSavingsSize, name, _getFileNameAndExtens, extension;

                    return regeneratorRuntime.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            _context.prev = 0;
                            _context.next = 3;
                            return _this3.compress(file.data);

                          case 3:
                            compressedBlob = _context.sent;
                            compressedSavingsSize = file.data.size - compressedBlob.size;

                            _this3.uppy.log("[Image Compressor] Image ".concat(file.id, " compressed by ").concat(prettierBytes(compressedSavingsSize)));

                            totalCompressedSize += compressedSavingsSize;
                            name = compressedBlob.name;
                            _getFileNameAndExtens = getFileNameAndExtension(name), extension = _getFileNameAndExtens.extension;

                            _this3.uppy.setFileState(file.id, {
                              name: name,
                              extension: extension,
                              type: compressedBlob.type,
                              data: compressedBlob,
                              size: compressedBlob.size
                            });

                            _context.next = 16;
                            break;

                          case 12:
                            _context.prev = 12;
                            _context.t0 = _context["catch"](0);

                            _this3.uppy.log("[Image Compressor] Failed to compress ".concat(file.id, ":"), 'warning');

                            _this3.uppy.log(_context.t0, 'warning');

                          case 16:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee, null, [[0, 12]]);
                  }));

                  return function (_x2) {
                    return _ref.apply(this, arguments);
                  };
                }());
                promises = fileIDs.map(function (fileID) {
                  var file = _this3.uppy.getFile(fileID);

                  _this3.uppy.emit('preprocess-progress', file, {
                    mode: 'indeterminate',
                    message: _this3.i18n('compressingImages')
                  });

                  if (file.isRemote) {
                    return Promise.resolve();
                  } // Some browsers (Firefox) add blobs with empty file type, when files are
                  // added from a folder. Uppy auto-detects type from extension, but leaves the original blob intact.
                  // However, Compressor.js failes when file has no type, so we set it here


                  if (!file.data.type) {
                    file.data = file.data.slice(0, file.data.size, file.type);
                  }

                  if (!file.type.startsWith('image/')) {
                    return Promise.resolve();
                  }

                  return compressAndApplyResult(file);
                }); // Why emit `preprocess-complete` for all files at once, instead of
                // above when each is processed?
                // Because it leads to StatusBar showing a weird “upload 6 files” button,
                // while waiting for all the files to complete pre-processing.

                _context2.next = 5;
                return Promise.all(promises);

              case 5:
                this.uppy.emit('compressor:complete'); // Only show informer if Compressor mananged to save at least a kilobyte

                if (totalCompressedSize > 1024) {
                  this.uppy.info(this.i18n('compressedX', {
                    size: prettierBytes(totalCompressedSize)
                  }), 'info');
                }

                _iterator = _createForOfIteratorHelper(fileIDs);

                try {
                  for (_iterator.s(); !(_step = _iterator.n()).done;) {
                    fileID = _step.value;
                    file = this.uppy.getFile(fileID);
                    this.uppy.emit('preprocess-complete', file);
                  }
                } catch (err) {
                  _iterator.e(err);
                } finally {
                  _iterator.f();
                }

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function prepareUpload(_x) {
        return _prepareUpload.apply(this, arguments);
      }

      return prepareUpload;
    }()
  }, {
    key: "install",
    value: function install() {
      this.uppy.addPreProcessor(this.prepareUpload);
    }
  }, {
    key: "uninstall",
    value: function uninstall() {
      this.uppy.removePreProcessor(this.prepareUpload);
    }
  }]);

  return Compressor;
}(_core.BasePlugin);

module.exports = Compressor;